"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var languageCodeConversion = {
  en: 'English',
  es: 'Spanish'
};
var _default = function _default(_ref) {
  var name = _ref.name;
  return {
    name: name,
    label: 'Language',
    sort: false,
    render: function render(_ref2) {
      var value = _ref2.value;
      return languageCodeConversion[value] || value;
    },
    filter: true,
    filterSettings: {
      type: 'selectbox',
      options: [{
        label: 'English',
        value: 'en'
      }, {
        label: 'Spanish',
        value: 'es'
      }]
    }
  };
};
exports["default"] = _default;